export default __webpack_public_path__ + "static/media/reply icon.aca2880f.svg";